// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rundeck-version-info{color:#8a8a8a}.rundeck-version-date{color:#d3d3d3;font-style:italic}.rundeck-version-tag{text-transform:uppercase}.rundeck-version-relative-date{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
